import React from "react";
import { RadioButton } from "primereact/radiobutton";
import { IOpcion } from "../../../interfaces/OpcionReembolso";
import { formatMoney } from "../../shared/utilitties/formatMoney";
import { useGlobalContext } from "../../shared/context/global.context";

interface Props {
  claseTrans: string;
  claseEmpre: string;
  opcion: IOpcion[]|undefined;
  transferencia: number;
  digital: number;
  medioPago: string;
  onClickTransferencia: Function|undefined;
  onClickDigital: Function|undefined;
  checkedTransferencia: boolean;
}

const TableAdelantar = (props: Props) => {
  const { userLogged } = useGlobalContext()
  return (
    <table className="table table-borderless">
      <thead>
        <tr>
          <th className="text-center" scope="col">
            Medio
          </th>
          <th
            className={
              "text-center " +
              props.claseTrans
                .replace("boxBlue", "topboxBlue")
                .replace("boxDisable", "topboxDisable")
            }
            scope="col"
          >
            Acreditación en cuenta
          </th>
          <th
            className={
              "text-center " +
              props.claseEmpre
                .replace("boxBlue", "topboxBlue")
                .replace("boxDisable", "topboxDisable")
            }
            scope="col"
          >
            Empresarial
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>TNM:</td>
          <td className={"text-center " + props.claseTrans}>
            {formatMoney(props.opcion && props.opcion[props.transferencia].tna / 12)}%
          </td>
          <td className={"text-center " + props.claseEmpre}>
            {formatMoney(props.opcion && props.opcion[props.digital].tna / 12)}%
          </td>
        </tr>
        <tr>
          <td>Plazo:</td>
          <td className={"text-right " + props.claseTrans}>
            {props.opcion && props.opcion[props.transferencia].plazoTexto}
          </td>
          <td className={"text-right " + props.claseEmpre}>
            {props.checkedTransferencia ? '0 Días' : props.opcion && props.opcion[props.digital].plazoTexto}
          </td>
        </tr>
        <tr>
          <td>Gasto Admin.:</td>
          <td className={"text-right " + props.claseTrans}>
            ${formatMoney(props.opcion && props.opcion[props.transferencia].gastoAdmin)}
          </td>
          <td className={"text-right " + props.claseEmpre}>
            ${props.checkedTransferencia ? '0,00' : formatMoney(props.opcion && props.opcion[props.digital].gastoAdmin)}
          </td>
        </tr>
        <tr>
          <td>Intereses:</td>
          <td className={"text-right " + props.claseTrans}>
            ${formatMoney(props.opcion && props.opcion[props.transferencia].intereses)}
          </td>
          <td className={"text-right " + props.claseEmpre}>
            ${props.checkedTransferencia ? 0 :  formatMoney(props.opcion && props.opcion[props.digital].intereses)}
          </td>
        </tr>
        <tr>
          <td>IVA:</td>
          <td className={"text-right " + props.claseTrans}>
            ${formatMoney(props.opcion && props.opcion[props.transferencia].IVA)}
          </td>
          <td className={"text-right " + props.claseEmpre}>
            ${props.checkedTransferencia ? 0 : formatMoney(props.opcion && props.opcion[props.digital].IVA)}
          </td>
        </tr>
        <tr>
          <td>Percepciones:</td>
          <td className={"text-right " + props.claseTrans}>
            ${formatMoney(props.opcion && props.opcion[props.transferencia].percepciones)}
          </td>
          <td className={"text-right " + props.claseEmpre}>
            ${props.checkedTransferencia ? 0 : formatMoney(props.opcion && props.opcion[props.digital].percepciones)}
          </td>
        </tr>
        <tr>
          <td>Costo Adelanto:</td>
          <td className={"text-right " + props.claseTrans}>
            ${formatMoney(props.opcion && props.opcion[props.transferencia].costoAdelanto)}
          </td>
          <td className={"text-right " + props.claseEmpre}>
            ${props.checkedTransferencia ? 0 : formatMoney(props.opcion && props.opcion[props.digital].costoAdelanto)}
          </td>
        </tr>
        <tr>
          <td>Monto Neto:</td>
          <td
            className={
              "text-right " +
              props.claseTrans
                .replace("boxBlue", "botboxBlue")
                .replace("boxDisable", "botboxDisable")
            }
          >
            $
            {formatMoney(
              props.opcion && props.opcion[props.transferencia].montoAcreditar < 0
                ? 0
                : props.opcion && props.opcion[props.transferencia].montoAcreditar
            )}
          </td>
          <td
            className={
              "text-right " +
              props.claseEmpre
                .replace("boxBlue", "botboxBlue")
                .replace("boxDisable", "botboxDisable")
            }
          >
            ${props.checkedTransferencia ? 0 : formatMoney(props.opcion && props.opcion[props.digital].montoAcreditar)}
          </td>
        </tr>
        <tr>
          <td></td>
          <td className="text-center">
            <RadioButton
              value="Transferencia"
              name="Transferencia"
              disabled = {userLogged.activeDirectory }
              checked={
                props.claseTrans == "boxDisable"
                  ? false
                  : props.medioPago === "Transferencia" ||
                    props.checkedTransferencia
              }
              onChange={() => props.onClickTransferencia && props.onClickTransferencia()}
            />
          </td>
          <td className="text-center">
            <RadioButton
              disabled={props.checkedTransferencia ||userLogged.activeDirectory }
              value="Digital"
              name="Digital"
              checked={
                props.claseEmpre == "boxDisable"
                  ? false
                  : props.medioPago === "Digital" && !props.checkedTransferencia
              }
              onChange={() => props.onClickDigital && props.onClickDigital()}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default TableAdelantar;
